import styles from './styles.module.scss';

function LastUpdatedTime({ timestamp }) {
  if (!timestamp) return null;
  const text = new Date(timestamp).toLocaleString();
  return <span className={styles.last_update_at}>Last Updated: {text}</span>;
}

export default LastUpdatedTime;
